// export const CLOCK_IN_REQUEST = 'CLOCK_IN_REQUEST';
export const CLOCK_IN_SUCCESS = 'CLOCK_IN_SUCCESS';
export const CLOCK_IN_FAILURE = 'CLOCK_IN_FAILURE';
// export const CLOCK_OUT_REQUEST = 'CLOCK_OUT_REQUEST';
export const CLOCK_OUT_SUCCESS = 'CLOCK_OUT_SUCCESS';
export const CLOCK_OUT_FAILURE = 'CLOCK_OUT_FAILURE';